<template>
    <v-container
            id="service-list"
            fluid
            tag="section"
            pt-0
    >
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :headers="headers"
                        :items="knowledgeBaseList"
                        sort-by="name"
                        class="elevation-1"
                        :options.sync="options"
                        :server-items-length="knowledgeBaseListTotal"
                        @click:row="handleKnowledgeBaseRowClick"
                >
                    <template v-slot:top>
                        <v-toolbar
                                flat
                        >
                            <v-text-field
                                    class="ml-2"
                                    outlined
                                    dense
                                    :label="$vuetify.lang.t('$vuetify.page.KnowledgeBase.search')"
                                    v-model="searchVal"
                                    :hide-details="true"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="primary"
                                    dark
                                    class="mb-2"
                                    @click="addKnowledgeBase"
                            >
                                {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}
                            </v-btn>
                        </v-toolbar>
                    </template>

                    <template v-slot:item.issue="{ item }">
                      {{ item.issue | striphtml(150) }}
                    </template>
                    <template v-slot:no-data>
                        Нет данных
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState} from 'vuex'
    import {actionType, getterType} from "@/store/knowledgeBase/knowledgebase";

    export default {
        name: 'KnowledgeBaseList',
        components: {},
        created() {
            this.getKnowledgeBaseList()
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            knowledgeBaseList() {
                return this.$store.getters[getterType.list]
            },
            knowledgeBaseListTotal() {
                return this.$store.getters[getterType.listTotal]
            },
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.crudName'))
            },
        },
        watch: {
            options: {
                handler() {
                    this.getKnowledgeBaseList()
                },
                deep: true,
            },
        },
        data() {
            return {
                vue: this,
                dialogDelete: false,
                options: {},
                searchVal: null,
                dialog: false,
                valid: !this.formError,
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.articleNo'),
                        align: 'start',
                        sortable: true,
                        value: 'articleNo',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.name'),
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.KnowledgeBase.issue'),
                        align: 'start',
                        sortable: true,
                        value: 'issue',
                    }
                ],
                editedItem:{
                    articleNo: null,
                    name: null,
                    issue: null,
                    solution: null
                }
            }
        },
        methods: {
            handleKnowledgeBaseRowClick(row){
                this.$store.dispatch(actionType.retrieveItem, row.id).then(() => {
                    this._openKnowledgeBaseCard(row.id)
                })
            },
            _openKnowledgeBaseCard(knowledgeBaseId) {
                this.$router.push({
                    name: 'KnowledgeBaseCard',
                    params: {
                        knowledgeBaseId: knowledgeBaseId
                    }
                })
            },
            getKnowledgeBaseList() {
                if (this.options.page) {
                    this.$store.dispatch(actionType.retrieveList, {
                        offset: (this.options.page - 1) * this.options.itemsPerPage,
                        limit: this.options.itemsPerPage,
                        search: this.searchVal
                    })
                }
            },
            search(){
                if(this.options.page !== 1){
                    this.options.page = 1
                } else {
                    this.getKnowledgeBaseList()
                }
            },
            addKnowledgeBase(){
                this._openKnowledgeBaseCard('00000000-0000-0000-0000-000000000000')
            },
            deleteItem(item) {
                this.editedIndex = this.userList.users.indexOf(item)
                this.editedItem = {...item}
                this.dialogDelete = true
            },
            close() {
                this.dialog = false
                this.editDialog = false
                this.changePasswordDialog = false
                this.editRolesDialog = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },
            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = {...this.defaultItem}
                    this.editedIndex = -1
                })
            },
            addItem() {
                if (this.$refs.form.validate()) {
                    this.editedItem.id = this.$uuid.v4()
                    this.$store.dispatch(actionType.create, this.editedItem).then(() => this.close())
                }
            },
        },
    }
</script>
